import { Component, OnInit, ViewChild, TemplateRef, Inject, ViewEncapsulation } from '@angular/core';
import { Paginacao, StatusTransacaoCredito, ContaCredito, RequestRecusarTransacaoType } from '../shared/services/acordo-ressarcimento/api/models';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PsModalLoadingComponent } from 'porto-seguro-guide';
import { EscritoriosService, DominiosService, ContaCreditoService, TransacaoCreditoService, UsuarioService } from '../shared/services/acordo-ressarcimento/api/services';
import { LoadingService } from '../shared/services/components/loading.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Observable, of } from 'rxjs';
import { TransacaoCreditoPaginado } from '../shared/services/acordo-ressarcimento/api/models/transacao-credito-paginado';
import { ConsultarTransacaoCreditoService } from './conciliacao-validacao.service';

@Component({
  selector: 'app-conciliacao-validacao',
  templateUrl: './conciliacao-validacao.component.html',
  styleUrls: ['./conciliacao-validacao.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConciliacaoValidacaoComponent implements OnInit {
  public transacaoPaginado: TransacaoCreditoPaginado;
  public formPesquisa: FormGroup;
  public formTransacao: FormGroup;
  public loadingLista = false;
  public selected = '';
  public page: Paginacao;
  source = [];
  columnsTemplate = [];
  public listaStatusTransacaoCredito: StatusTransacaoCredito[];
  public listaEscritoriosFiltro: any[];
  public listaContasCredito: ContaCredito[];
  public nomeEscritorioFiltro: any[];
  public numeroTransacao = {};
  public flagCancelaTransacao: boolean;
  public codigoEscritorio: number;
  public nomeEscritorio: string;
  public isEscritorio: boolean;
  public escritorio: any;

  @ViewChild('templateValorTransacao') private templateValorTransacao: TemplateRef<any>;
  @ViewChild('templateDataTransacao') private templateDataTransacao: TemplateRef<any>;
  @ViewChild('templateDetalheTransacao') private templateDetalheTransacao: TemplateRef<any>;
  @ViewChild('templateCancelarTransacao') private templateCancelarTransacao: TemplateRef<any>;
  @ViewChild('ModalConcluidoTransacao') modalConcluidoTransacao: PsModalLoadingComponent;
  @ViewChild('templatedataValidacao') private templatedataValidacao: TemplateRef<any>;

  constructor(
    private formBuilder: FormBuilder,
    public escritorioService: EscritoriosService,
    public dominiosService: DominiosService,
    public transacaoCreditoService: TransacaoCreditoService,
    public consultaTransacaoService: ConsultarTransacaoCreditoService,
    private contaCreditoService: ContaCreditoService,
    private usuarioService: UsuarioService,
    private loading: LoadingService,
    private router: Router,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    if( sessionStorage.getItem('codigoEscritorio') && sessionStorage.getItem('codigoEscritorio') != "" ) {
        this.codigoEscritorio = JSON.parse(sessionStorage.getItem('codigoEscritorio'));
    }
    this.nomeEscritorio = sessionStorage.getItem('nomeEscritorio');
    this.isEscritorio = JSON.parse(sessionStorage.getItem('isEscritorio'));

    this.flagCancelaTransacao = JSON.parse(sessionStorage.getItem('flagCancelaTransacao'));

    this.columnsTemplate = [
      { prop: 'numeroTransacao', label: 'N° transação' },
      { label: 'Valor', template: this.templateValorTransacao },
      { label: 'Data', template: this.templateDataTransacao },
      { label: 'Data Ultima Validação', template: this.templatedataValidacao },
      { prop: 'qtdParcelas', label: 'Qtde parcelas' },
      { prop: 'statusTransacao.descricao', label: 'Status' },
      { label: 'Detalhe', template: this.templateDetalheTransacao },
    ];
    if (this.flagCancelaTransacao == true) {
      this.columnsTemplate.push({ label: 'Cancelar', template: this.templateCancelarTransacao },);
    }

    this.transacaoPaginado = undefined;
    this.criarFormPesquisa();
    this.criarFormTransacao();

    this.carregarDadosPagina();

    this.carregarStatusTransacao();
    this.carregarContasCredito();

    if (this.consultaTransacaoService.isRealizaPesquisa
      && this.consultaTransacaoService.isRealizaPesquisa() === true
      && this.consultaTransacaoService.getParametrosPesquisa) {
      this.consultaTransacaoService.setRealizaPesquisa(false);
      this.formPesquisa = this.consultaTransacaoService.getFormPesquisa();
      this.pesquisarTransacoes(this.consultaTransacaoService.getParametrosPesquisa()['page']);
    }
  }

  carregarDadosPagina() {
    this.usuarioService.recuperarDadosUsuario().subscribe(result => {
      this.formPesquisa.controls['ramoSinistro'].setValue( result.produto );

      if( result.codigoEscritorio ) {
        this.codigoEscritorio = result.codigoEscritorio;
     }

      if( result.nomeEscritorio ) {
        this.nomeEscritorio = result.nomeEscritorio;
      }

      this.isEscritorio = result.flagEscritorio;
    });
  }

  public criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      ramoSinistro: null,
      numeroSinistro: null,
      anoSinistro: null,
      sequenciaItemSinistro: null,
      codigoContaCredito: null,
      numeroTransacao: null,
      statusTransacao: null,
      escritorio: this.nomeEscritorio != null ? this.nomeEscritorio : null,
      codigoEscritorio: this.codigoEscritorio != null ? this.codigoEscritorio : null,
      dataDe: null,
      dataAte: null,
      valorInicio: null,
      valorFinal: null,
    });
  }

  private criarFormTransacao() {
    this.formTransacao = this.formBuilder.group({
      textoJustificativaReprovacao: null
    });
  }

  public recarregarPagina() {
    setTimeout(() => {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.consultaTransacaoService.setRealizaPesquisa(true);
        this.router.navigate(['conciliacao-validacao']);
      });
    }, 500);
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio: this.formPesquisa.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(
        data => {
          this.listaEscritoriosFiltro = data;
          for (let key in data) {
            this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
          }
        }
      );
      return of(this.nomeEscritorioFiltro);
    };
  }

  public autoCompleteBuscaEscritorioSelected($event) {
    this.selected = $event;

    for (let key in this.listaEscritoriosFiltro) {
      if (this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected) {
        this.formPesquisa.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  public log(event) {
    console.log(event);
  }

  public carregarContasCredito() {
    this.contaCreditoService.obterContasCredito().subscribe(result => {
      this.listaContasCredito = result;
    });
  }

  public carregarStatusTransacao() {
    this.dominiosService.obterSituacaoTransacaoCredito().subscribe(result => {
      this.listaStatusTransacaoCredito = result;
    });
  }

  public pesquisarTransacoes(page) {
    this.loading.open();
    this.transacaoPaginado = undefined;

    if (this.tratarCondicao(this.escritorio) == null && this.isEscritorio === false) {
      this.formPesquisa.controls['codigoEscritorio'].setValue(null);
    }

    var parametros: TransacaoCreditoService.ObterTransacoesParams = {
      ramoSinistro: this.tratarCondicao(this.formPesquisa.value['ramoSinistro']),
      numeroSinistro: this.tratarCondicao(this.formPesquisa.value['numeroSinistro']),
      anoSinistro: this.tratarCondicao(this.formPesquisa.value['anoSinistro']),
      sequenciaItemSinistro: this.tratarCondicao(this.formPesquisa.value['sequenciaItemSinistro']),
      codigoContaCredito: this.tratarCondicao(this.formPesquisa.value['codigoContaCredito']),
      numeroTransacao: this.tratarCondicao(this.formPesquisa.value['numeroTransacao']),
      codigoStatus: this.tratarCondicao(this.formPesquisa.value['statusTransacao']),
      codigoEscritorio: this.tratarCondicao(this.formPesquisa.value['codigoEscritorio']),
      periodoInicial: this.tratarCondicao(this.formPesquisa.value['dataDe']),
      periodoFinal: this.tratarCondicao(this.formPesquisa.value['dataAte']),
      valorInicial: this.tratarCondicao(this.formPesquisa.value['valorInicio']),
      valorFinal: this.tratarCondicao(this.formPesquisa.value['valorFinal']),
      page: page == undefined ? 0 : page,
      perPage: 10,
    };

    this.consultaTransacaoService.addDadosPesquisa(parametros, this.formPesquisa);

    this.transacaoCreditoService.obterTransacoes(parametros).subscribe(response => {
      this.loading.close();
      this.transacaoPaginado = response;
      this.page = this.transacaoPaginado.paginacao;
      this.loadingLista = false;
      this.source = this.transacaoPaginado.transacoes;
    }, error => {
      this.loading.close();
      const theError: string = error.error.mensagens[2].mensagem;
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });
  }

  public paginar(evt) {
    this.pesquisarTransacoes(evt.offset);
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  public visualizarDetalhesTransacao(numeroTransacao: number) {
    this.router.navigate(['/detalhe-validacao/' + numeroTransacao]);
  }

  public cancelarTransacao(numeroTransacao: number, ModalDialog) {
    if (this.formTransacao.value['textoJustificativaReprovacao'] == null || this.formTransacao.value['textoJustificativaReprovacao'] == '') {
      this.appComponent.createAlert("É necessário informar uma justificativa!", 'error');
      return;
    } else {
      ModalDialog.close();
      this.loading.open();

      var parametros: RequestRecusarTransacaoType = {
        numeroTransacao: numeroTransacao,
        textoJustificativaReprovacao: this.formTransacao.value['textoJustificativaReprovacao']
      }

      this.transacaoCreditoService.cancelarTransacao(parametros).subscribe(response => {
        this.loading.close();
        this.modalConcluidoTransacao.open(null);
      }, error => {
        this.loading.close();
        const theError: string = error.error.mensagens[2].mensagem;
        this.loadingLista = false;
        this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      });
    }
  }

  public openReprovarTransacao(numeroTransacao: number) {
    this.numeroTransacao = numeroTransacao;
  }

  public tratarCondicao(valor: any) {
    if (valor !== undefined && valor !== null && valor === '') {
      return null;
    }
    return valor;
  }

  public tratarValor(valor: any) {
    if (this.formPesquisa.get(valor).value === 0
        ||  this.formPesquisa.get(valor).value === '') {
          this.formPesquisa.get(valor).setValue(null);
      }
  }

}
